import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  itemParent: {
    display: 'flex',
    borderBottom: '1px solid #F1F1F1',
    '&:last-child': {
      borderBottom: 'none !important',
    },
  },
  itemLine: {
    flexShrink: 0,
    fontSize: 12,
    color: 'black',
    fontFamily: 'Poppins !important',
    fontWeight: 500,
    margin: 'auto 0px',
    marginRight: 5,
    position: 'relative',
    '&:hover $tooltipLabel': {
      visibility: 'visible',
      opacity: 1,
    },
    '& span': {
      fontFamily: 'Poppins !important',
    },
  },
  status: {
    display: 'flex',
    alignItems: 'center',
    '& ::first-letter': {
      textTransform: 'uppercase',
    },
  },
  tooltipLabel: {
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'Open Sans',
    fontSize: '12px',
    fontWeight: 800,
    backgroundColor: '#f1f1f1',
    color: 'black',
    padding: '10px 12px 9px',
    borderRadius: 5,
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0s, opacity 0.5s linear',
    zIndex: 1,
    cursor: 'pointer',
    textWrap: 'nowrap',
    width: 'auto !important',
  },
  overflowText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  matchingGlobal: {
    border: '1px solid #000A8C',
    position: 'absolute',
    width: 590,
    height: 'auto',
    left: '-250%',
    borderRadius: 5,
    background: 'white',
    zIndex: 99,
  },
  text: {
    fontSize: 14,
    color: '#000A8C',
    fontWeight: 700,
    fontFamily: 'Poppins',
    marginLeft: 20,
    marginTop: 20,
    marginBottom: 20,
  },
  matchTitle: {
    fontFamily: 'Poppins !important',
    fontSize: 12,
    fontWeight: 500,
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '20px 10px',
  },
  iconBtnImageLogout: {
    position: 'absolute',
    top: '5%',
    right: '2%',
    zIndex: 2,
    color: '#E63C3C',
    textTransform: 'none',
  },
});
